export interface UniqueItem {
    uniqueKey: string;
}
